/**
 * Rolling monthly broadband — the ONE place the website states its facts (owner 2026-10-16:
 * "we do all plans from 1 month for broadband and SIM").
 *
 * Catalogue (checked 2026-10-16, products 239-242, `is_rolling_contract`):
 *   Broadband Lite – Three – 1 Month   £25.95/mo + £30 refundable holding deposit
 *   Broadband Lite – O2    – 1 Month   £43.50/mo + £25 refundable holding deposit
 *   5G Premium     – Three – 1 Month   £38.95/mo + £45 refundable holding deposit
 *   5G Premium     – O2    – 1 Month   £57.95/mo + £45 refundable holding deposit
 *
 * It IS a contract — signed online, paid monthly by Direct Debit, 1-month minimum term,
 * then month to month until the customer gives 30 days' notice. Never call it "no contract".
 * If a price changes in Admin → Products, change it here too, then run live-frontend-seo.
 */
export const ROLLING = {
  litePrice: '25.95',
  liteDeposit: '30',
  premiumPrice: '38.95',
  premiumDeposit: '45',
  o2LitePrice: '43.50',
  o2PremiumPrice: '57.95',
  notice: '30 days',
  /** Every broadband term we sell, shortest first. */
  terms: '1 (rolling monthly), 3, 6, 12, 18, 24 or 36 months',
  termsShort: '1 to 36 months',
}

export interface RollingFaq { question: string; answer: string }

/** Rolling month-to-month FAQs. `where` personalises them for a town page ("in Leeds"). */
export const rollingFaqs = (where = ''): RollingFaq[] => [
  {
    question: `Do you offer rolling monthly broadband${where}?`,
    answer: `Yes. Broadband Lite and 5G Premium are available${where} on a rolling monthly contract: a 1-month minimum term, then it carries on month to month until you give ${ROLLING.notice}' notice. Broadband Lite is from £${ROLLING.litePrice}/month and 5G Premium from £${ROLLING.premiumPrice}/month on Three, with the router included.`,
  },
  {
    question: 'Is a rolling monthly plan still a contract?',
    answer: `Yes. It is a 1-month contract that you sign online and pay monthly by Direct Debit. There is no long minimum term to sit out — after the first month you can leave whenever you like by giving ${ROLLING.notice}' notice.`,
  },
  {
    question: 'How do I cancel a rolling monthly plan?',
    answer: `Give ${ROLLING.notice}' notice using the online Cancel Contract page in your Silux Mobile account, or email info@siluxmobile.co.uk. Your service and payments stop at the end of the notice period.`,
  },
  {
    question: 'Is there a deposit on rolling monthly broadband?',
    answer: `Yes — a refundable holding deposit is taken with your first payment: £${ROLLING.liteDeposit} on Broadband Lite and £${ROLLING.premiumDeposit} on 5G Premium (Three). It is refunded at the end of your contract. There is no setup fee.`,
  },
  {
    question: 'What is the shortest plan you offer?',
    answer: `All our plans start from 1 month. SIM cards are available on 30-day rolling plans or 3, 6, 12 or 24-month contracts, and broadband is available on a rolling monthly contract or a fixed term of 3, 6, 12, 18, 24 or 36 months — the longer the term, the lower the monthly price.`,
  },
  {
    question: 'Why does a rolling monthly plan cost more than a 24-month plan?',
    answer: `You are paying for the freedom to leave with ${ROLLING.notice}' notice. If you know you will stay longer, a fixed term is cheaper — Broadband Lite is £15.95/month over 24 months and 5G Premium £19.95/month over 36 months.`,
  },
  {
    question: 'Can I switch from a rolling monthly plan to a cheaper, longer plan?',
    answer: 'Yes. Log in and go to Renew or Upgrade in your account, choose a longer plan and we will email your new contract to sign. Your service carries on as normal with the same router.',
  },
  {
    question: 'Which networks are rolling monthly plans available on?',
    answer: `Three and O2. On Three, Broadband Lite is £${ROLLING.litePrice}/month and 5G Premium £${ROLLING.premiumPrice}/month; on O2, Broadband Lite is £${ROLLING.o2LitePrice}/month and Premium £${ROLLING.o2PremiumPrice}/month. Check your postcode on our coverage checker before you order.`,
  },
]
